module.exports = __webpack_public_path__ + "img/avatar_5.f65e9bb4.png";